import { createIcon } from "@chakra-ui/icons";
import { IconProps } from "@chakra-ui/react";

// Created from rana-logo.svg

export const RanaLogoIcon = createIcon({
  displayName: "Rana Logo",
  viewBox: "0 0 27 11",
  path: (
    <path
      d="M1.36367 10.3002C2.66883 5.95457 6.259 2.58866 10.7336 1.60558C9.13946 3.51915 7.86172 6.88879 7.29798 10.3002H8.62078C9.45773 5.5011 11.7365 1.30985 13.4406 1.30985C15.1448 1.30985 17.4236 5.50112 18.2606 10.3002H19.5822C19.2621 8.36877 18.7093 6.42847 17.9744 4.73328C17.3596 3.31516 16.7406 2.31258 16.1553 1.60735C20.6264 2.59259 24.2133 5.95708 25.5177 10.3002H26.8814C25.2843 4.37428 19.8641 0 13.4406 0C7.01712 0 1.59701 4.37428 0 10.3002H1.36367Z"
      fill="currentColor"
    />
  ),
});

export const RanaLogoSmall = ({ width = "36px", height = "14px", ...rest }: IconProps) => (
  <RanaLogoIcon width={width} height={height} {...rest} />
);

export const RanaLogoLarge = ({ width = "85px", height = "32px", ...rest }: IconProps) => (
  <RanaLogoIcon width={width} height={height} {...rest} />
);
